var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.369,
    height: 53.369,
    viewBox: "0 0 53.369 53.369",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-add-circle",
    "data-name": "Icon ionic-ios-add-circle",
    d: "M30.06,3.375A26.685,26.685,0,1,0,56.744,30.06,26.681,26.681,0,0,0,30.06,3.375ZM41.67,32.112H32.112V41.67a2.053,2.053,0,0,1-4.105,0V32.112H18.449a2.053,2.053,0,1,1,0-4.105h9.558V18.449a2.053,2.053,0,1,1,4.105,0v9.558H41.67a2.053,2.053,0,0,1,0,4.105Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#ec6321"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.199f832287d7b7c959623ff9d3eebd43.svg";
export { ForwardRef as ReactComponent };